import { render, staticRenderFns } from "./ReservedBooks.vue?vue&type=template&id=e22a145e&scoped=true&"
import script from "./ReservedBooks.vue?vue&type=script&lang=js&"
export * from "./ReservedBooks.vue?vue&type=script&lang=js&"
import style0 from "./ReservedBooks.vue?vue&type=style&index=0&id=e22a145e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e22a145e",
  null
  
)

export default component.exports